/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { HousePlanFinderDialogComponent } from './house-plan-finder-dialog.component';

export const housePlanFinderDialogRoute = createDialogRoute({
  component: HousePlanFinderDialogComponent,
});
